module.exports = __webpack_public_path__ + "static/media/cloud_upload-24px.951f951c.svg";